import React from "react";
import Logo from "../../../images/DpLogo.png";
import {InvoiceProps} from "src/layouts/AdminPortal/Subscriptions/InvoiceInterface";

const InvoiceTemplate: React.FC<InvoiceProps> = ({ data }) => {
  const {
    tenant_name,
    billing_address,
    invoice_number,
    payment_date,
    due_date,
    status,
    package_name,
    package_price,
    total_price,
    notes,
    additional_user_seats = 0,
    price_per_extra_user = 0,
    extra_users_cost = 0,
  } = data;

  return (
    <div className="invoice-page-wrapper">
      <div className="invoice-container">
        <div className="invoice-header" aria-label="Invoice Header">
          <div className="invoice-logo-section">
            <img src="/images/DpLogo.png" alt="logo" className="invoice-logo" />
          </div>
          <div className="invoice-info-section">
            <p className="invoice-heading invoice-bold">INVOICE</p>
            <div className="invoice-detail-row">
              <span className="invoice-bold">Invoice</span>
              <span>{invoice_number}</span>
            </div>
            <div className="invoice-detail-row">
              <span className="invoice-bold">Generated</span>
              <span>{payment_date}</span>
            </div>
            <div className="invoice-detail-row">
              <span className="invoice-bold">Due Date</span>
              <span>{due_date}</span>
            </div>
            <div className="invoice-detail-row">
              <span className="invoice-bold">Status</span>
              <span
                style={{
                  color: status === "paid" ? "green" : "orange",
                  fontWeight: "bold",
                  textTransform: "capitalize",
                }}
              >
                {status}
              </span>
            </div>
          </div>
        </div>
<div className="invoice-bill-wrap">
  <div className="invoice-bill-to">
    <p className="invoice-bold bill-to-heading">Bill To</p>
    {tenant_name ? (
      <p className="invoice-bold invoice-name">{tenant_name}</p>
    ) : (
      <p className="invoice-error">No tenant information available</p>
    )}
    {billing_address ? (
      <span className="address-description">{billing_address}</span>
    ) : (
      <span className="address-description invoice-error">No address provided</span>
    )}
  </div>
  <div className="total-due-section" style={{ marginTop: "20px",textAlign: "left" }}>
    <p className="address-description">Total Due</p>
    {typeof total_price === "number" && !isNaN(total_price) ? (
      <p className="invoice-bold invoice-price" style={{textAlign:"right"}} >
        USD: ${total_price.toFixed(2)}
      </p>
    ) : (
      <p className="invoice-bold invoice-error">Invalid amount</p>
    )}
  </div>
</div>
    
        <div className="invoice-main-table" aria-label="Invoice Items Table">
          <div className="invoice-table-header">
            <div className="invoice-col-description invoice-table-col">
              Description
            </div>
            <div className="invoice-col-qty invoice-table-col">Quantity</div>
            <div className="invoice-col-unit-price invoice-table-col">
              Unit Price
            </div>
            <div className="invoice-col-amount invoice-table-col">Amount</div>
          </div>

          <div className="invoice-table-row">
            <div className="invoice-col-description invoice-table-col">
              <p>{package_name.charAt(0).toUpperCase() + package_name.slice(1)} Plan</p>
            </div>
            <div className="invoice-col-qty invoice-table-col">
              <p>1</p>
            </div>
            <div className="invoice-col-unit-price invoice-table-col">
              <p>${package_price.toFixed(2)}</p>
            </div>
            <div className="invoice-col-amount invoice-table-col">
              <p>${package_price.toFixed(2)}</p>
            </div>
          </div>

          <div className="invoice-table-row">
            <div className="invoice-col-description invoice-table-col">
              <p>Additional User Seats</p>
            </div>
            <div className="invoice-col-qty invoice-table-col">
              <p>{additional_user_seats}</p>
            </div>
            <div className="invoice-col-unit-price invoice-table-col">
              <p>${price_per_extra_user.toFixed(2)}</p>
            </div>
            <div className="invoice-col-amount invoice-table-col">
              <p>${extra_users_cost.toFixed(2)}</p>
            </div>
          </div>
        </div>

        <div className="invoice-summary-section" aria-label="Invoice Summary">
          <div className="invoice-totals">
            <p className="invoice-bold">
              <span>SUBTOTAL</span>
              <span>${(package_price + extra_users_cost).toFixed(2)}</span>
            </p>
            <p>
              <span>Tax (0%)</span>
              <span>$0.00</span>
            </p>
            <p className="invoice-bold">
              <span>Total</span>
              <span>${total_price.toFixed(2)}</span>
            </p>
          </div>
        </div>

        {notes && (
          <div className="invoice-notes-section ">
            <p className="invoice-notes-heading">Notes</p>
            <p className="invoice-notes">{notes}</p>
          </div>
        )}

        <div className="invoice-table-header">
          <p className="finance-email">finance@datatram.ai</p>
        </div>
      </div>
    </div>
  );
};

export default InvoiceTemplate;
